var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3810_24485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.834 2.75V6.41667C12.834 6.65978 12.9306 6.89294 13.1025 7.06485C13.2744 7.23676 13.5075 7.33333 13.7507 7.33333H17.4173",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.584 19.25H6.41732C5.93109 19.25 5.46477 19.0568 5.12096 18.713C4.77714 18.3692 4.58398 17.9029 4.58398 17.4167V4.58333C4.58398 4.0971 4.77714 3.63079 5.12096 3.28697C5.46477 2.94315 5.93109 2.75 6.41732 2.75H12.834L17.4173 7.33333V17.4167C17.4173 17.9029 17.2242 18.3692 16.8803 18.713C16.5365 19.0568 16.0702 19.25 15.584 19.25Z",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16732 16.5005L13.7507 11.9171C13.9938 11.674 14.1303 11.3443 14.1303 11.0005C14.1303 10.6566 13.9938 10.3269 13.7507 10.0838C13.5075 9.84068 13.1778 9.7041 12.834 9.7041C12.4902 9.7041 12.1604 9.84068 11.9173 10.0838L7.33398 14.6671V16.5005H9.16732Z",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3810_24485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtn);
export default __webpack_public_path__ + "static/media/edit-btn.20c09b15e3b98a6057e67d482365a5d0.svg";
export { ForwardRef as ReactComponent };